<template>
  <ul class="step-breadcrumb">
    <li class="is-active">
      <span class="number">1</span>
      <span class="icon"><i class="fal fa-chevron-right"></i></span>
      <p>신청 정보 입력</p>
    </li>
    <li>
      <span class="number">2</span>
      <span class="icon"><i class="fal fa-chevron-right"></i></span>
      <p>서비스 비용 결제</p>
    </li>
    <li>
      <span class="number">3</span>
      <span class="icon"><i class="fal fa-chevron-right"></i></span>
      <p>관리 정보 입력</p>
    </li>
    <li>
      <span class="number">4</span>
      <p>정보 확인</p>
    </li>
  </ul>
</template>

<script>
export default {
name: "StepGraph"
}
</script>

<style scoped>

</style>